/**
 * Every `useJsApiLoader` / LoadScript call must use identical options or the
 * Maps JS loader throws: "Loader must not be called again with different options."
 */
export const GOOGLE_MAP_SCRIPT_ID = "google-map-script";

/** Keep order stable; use this everywhere Maps API is loaded. */
export const GOOGLE_MAPS_LOADER_LIBRARIES = ["places", "geometry"] as const;

export function getGoogleMapsApiKey(): string {
  return (
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY ??
    import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY ??
    ""
  ).trim();
}
